export enum ViewModes {
    TABLE = 'table',
    CARD = 'card',
    GRID = 'grid',
    CALENDAR = 'calendar',
    KANBAN = 'kanban'
  }
  
  export const ViewModeOptions = [
    {
      value: ViewModes.TABLE,
      label: 'Lista',
      icon: 'mdi-format-list-checkbox',
    },
    {
      value: ViewModes.CARD,
      label: 'Lista Amplia',
      icon: 'mdi-view-list',
    },
    {
      value: ViewModes.GRID,
      label: 'Cuadrícula',
      icon: 'mdi-grid',
    },
    {
      value: ViewModes.CALENDAR,
      label: 'Calendario',
      icon: 'mdi-calendar',
    },
    {
      value: ViewModes.KANBAN,
      label: 'Kanban',
      icon: 'mdi-view-column',
    }
  ];
  